import { useState, useEffect } from "react";
import { useSearchParams, useLocation, Link } from "react-router-dom";
import LavorisService from "../../services/LavorisService";
import { IndividualEmployeeResponseService } from "../../services/Company/Employee.type";
import { EditButton } from "../../components/others/EditButton/index";
import StyledWrapper from "./style";
import EmployeeData from "./EmployeeData";
import EmployeeTurns from "./EmployeeTurns";
import EditEmployeeModal from "../others/editEmployee";
import EmployeeAbsences from "./EmployeeAbsences";
import { useModal } from "../../hooks";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/core/Button";
import { positionsPlaceholder } from "../Turnos/positions";

const EmployeeProfile = () => {
  //Helper Functions
  let getCurrentTab = () => {
    //Check which page it is on
    const pathname = window.location.pathname;
    let result = pathname.includes("Datos")
      ? "datos"
      : pathname.includes("Turnos")
      ? "turnos"
      : pathname.includes("Ausentismo")
      ? "ausentismo"
      : "";
    return result;
  };

  //useNavigate
  const navigate = useNavigate()

  //Lavoris Instance
  const LavorisInstance = LavorisService.getInstance();

  //useLocation Hook
  const location = useLocation();

  //useModal
  const {openModal, closeModal, isActive} = useModal()

  // useStates
  const [data, setData] = useState<IndividualEmployeeResponseService>();
  const [searchParams, setSearchParams] = useSearchParams("");
  const [currentTab, setCurrentTab] = useState<any>(() => {
    getCurrentTab();
  });

  //CONSTANTS
  const employeeID = searchParams.get("id");
  const urlParam = employeeID ? `?id=${employeeID}` : "";

  // HandleCloses
  const handleClose = (urlElement: string) => {
    closeModal(urlElement)
  }

  // useEffects
  useEffect(() => {
    const getCompanyProfile = async () => {
      try {
        const individualEmployee =
          await LavorisInstance.CompanyServices.getIndividualEmployee(
            employeeID ? employeeID : "",
          );
        if (individualEmployee) {
          setData(individualEmployee);
        }
      } catch (e) {
        console.log(e);
      }
    };
    getCompanyProfile();
  }, []);

  //useEffects
  useEffect(() => {
    setCurrentTab(getCurrentTab());
  }, [location]);

  // const formatPosition = (position: string | undefined) => {
  //   if(!position) return "Empleado"
  //   const posFiltered = positionsPlaceholder.find((pos) => pos.value === position)
  //   if(posFiltered) return posFiltered.name
  //   const pos = position.split("_").join(" ").toLocaleLowerCase()
  //   return pos
  // }


  return (
    <div className="p-0 sm:p-3 bg-white">
      <Button
        type="button"
        className="leading-4 lav-black flex w-full justify-start p-0 pb-4 bg-white border-none"
        onClick={() => navigate(`/Empleados`)} 
        text={""}>
        <IoIosArrowBack className="text-xl flex align-center" />
        <span>Volver a listado</span>
      </Button>
      <h2 className="font-bold text-xl fontSize-2xl mb-4">Detalle de Empleado</h2>

      <div className="w-full bg-neutral-100 rounded-lg flex items-center px-8 py-3.5 gap-5 mb-8">
        <div className="w-20 h-20 rounded-full">
          <img src="/images/Profile.svg" alt="Perfil" className="bg-white rounded-full drop-shadow-lg"/>
        </div>
        <div className="flex flex-col max-w-xs">
          <p className="font-bold text-xl text-black leading-6">{data?.name}</p>
          <p className="font-normal text-xs text-zinc-400 mt-2">
            {data?.positionName}
          </p>
          {/* 
          <p className="font-normal text-xs text-zinc-400 mt-2">
            Tu perfil en Lavoris todavía no está completo. Mejorá la experiencia
            en tu consulta con un profesional y completá la mayor cantidad de
            información posible.
          </p> */}
        </div>
        {/* <div className="ml-auto">
          <EditButton
            text="Editar Datos"
            type="button"
            onClick={() => {
              openModal("modalEditarEmpleado")
            }}
          />
        </div> */}
      </div>

      <ul className="flex gap-8 mb-7">
        <StyledWrapper.ListItem
          active={currentTab === "datos" ? true : false}
          onClick={() => {
            setCurrentTab("datos");
          }}
        >
          <Link to={`/Perfil/Empleado/Datos${urlParam}`}>Datos personales</Link>
        </StyledWrapper.ListItem>
        {/*<StyledWrapper.ListItem
          active={currentTab === "turnos" ? true : false}
          onClick={() => {
            setCurrentTab("turnos");
          }}
        >
          <Link to={`/Perfil/Empleado/Turnos${urlParam}`}>Turnos y resultados</Link>
        </StyledWrapper.ListItem>
        <StyledWrapper.ListItem
          active={currentTab === "ausentismo" ? true : false}
          onClick={() => {
            setCurrentTab("ausentismo");
          }}
        >
          <Link to={`/Perfil/Empleado/Ausentismo${urlParam}`}>Ausentismo</Link>
        </StyledWrapper.ListItem>*/}
      </ul>

      {/* RENDER CORRECT INFO */}
      {currentTab === "datos" && <EmployeeData data={data} />}
      {/*
      {currentTab === "turnos" && <EmployeeTurns />}
      {currentTab === "ausentismo" && <EmployeeAbsences />}
        */}  
      {isActive("modalEditarEmpleado") && 
        <EditEmployeeModal
          onClose={handleClose}
          urlTittle={"modalEditarEmpleado"}
          toggleModal
        />
      }

    </div>
  );
};
export default EmployeeProfile;
